import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const FamilyOffice = ({ t, lang }) => (
  <section className="bg-sand/60 border-y border-line py-24 md:py-32" data-testid="family-office-section">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-7">
          <motion.p
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="text-xs uppercase tracking-[0.25em] font-bold text-taupe mb-6"
            data-testid="family-office-overline"
          >
            {t.familyOffice.overline}
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="font-heading font-light tracking-tight text-4xl md:text-5xl leading-[1.05]"
            data-testid="family-office-title"
          >
            {t.familyOffice.title}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="mt-8 text-smoke text-base md:text-lg font-light leading-relaxed"
            data-testid="family-office-body"
          >
            {t.familyOffice.body}
          </motion.p>
          <motion.a
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
            href={lang === "de" ? "/private-family-office-schweiz" : "/en/private-family-office-switzerland"}
            className="group mt-10 inline-flex items-center gap-2 text-sm font-semibold tracking-wide text-ink hover:text-taupe transition-colors duration-300"
            data-testid="family-office-more-link"
          >
            {t.familyOffice.more}
            <ArrowUpRight size={16} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </motion.a>
        </div>
        <div className="lg:col-span-5 flex flex-col justify-end">
          {t.familyOffice.points.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: 0.15 + i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="flex items-start gap-5 border-t border-line py-6 last:border-b"
              data-testid={`family-office-point-${i}`}
            >
              <span className="font-heading italic text-taupe text-2xl leading-none mt-0.5">{String(i + 1).padStart(2, "0")}</span>
              <p className="text-base md:text-lg font-light leading-relaxed">{p}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
